module.exports = __webpack_public_path__ + "img/bbc.f4e74d7d.webp";